import { render, staticRenderFns } from "./ProjectComponent.vue?vue&type=template&id=515dcd9f&scoped=true&"
import script from "./projectComponent.js?vue&type=script&lang=js&"
export * from "./projectComponent.js?vue&type=script&lang=js&"
import style0 from "./ProjectComponent.vue?vue&type=style&index=0&id=515dcd9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515dcd9f",
  null
  
)

export default component.exports